import {html, LitElement} from 'lit';
import styles from './g-tab-panel.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class GenesisTabPanel extends LitElement {
	static styles = [styles];

	static get properties () {
		return {
			id: {
				type: String
			},
			open: {
				type: Boolean
			}
		};
	}

	constructor () {
		super();
		this.id = '';
		this.label = '';
		this.open = false;

		// Set default aria attributes
		this.setAttribute('role', 'tabpanel');
	}

	/**
	 * Request and wait for updates for all slotted children; this prevents weird rendering issues
	 */
	async forceChildrenToUpdate () {
		const promises = [];
		const slot = this.renderRoot.querySelector('slot');

		if (slot) {
			const children = slot.assignedElements({flatten: true});
			for (let child of children) {
				child?.requestUpdate?.();
				promises.push(child?.updateComplete);
			}
		}

		await promises;
	}

	async updated (changedProperties) {
		if (changedProperties.has('id')) {
			this.setAttribute('aria-labelledby', `tab-${this.id}`);
		}

		if (changedProperties.has('open')) {
			if (this.open === true) {
				await this.forceChildrenToUpdate();
			}

			this.hidden = !this.open;
		}
	}

	render () {
		return html`
			<div class="container">
				<div class="inner">
					<slot></slot>
				</div>
			</div>
		`;
	}
};

defineCustomElement('g-tab-panel', GenesisTabPanel);
